import type { WorkspaceAppManifest } from './workspaceManifest';

export const APP_MANIFEST = {
    appId: 'settings',
    permissionsPrefix: 'settings',
    displayName: 'Settings',

    navSections: [
        { key: 'dashboard',      label: 'Dashboard',         route: '/settings/dashboard' },
        { key: 'usersCompanies', label: 'Users & Companies', route: '/settings/usersCompanies' },
    ],

    resources: [
        { key: 'users',              label: 'Users',              navSection: 'usersCompanies' },
        { key: 'securityGroups',     label: 'Security groups',    navSection: 'usersCompanies' },
        { key: 'documentSequences',  label: 'Document sequences', navSection: 'usersCompanies' },
        { key: 'approvalWorkflows',  label: 'Approval workflows', navSection: 'usersCompanies' },
    ],
} satisfies WorkspaceAppManifest;
